module.exports = __webpack_public_path__ + "media/sp2.37aba7f3.mp4";